<template>
    <TxAddToCartPortal>
        <love-map-button
                v-if="$root.env === 'frontend'"
                :class="[{'lm-add-to-cart':addToCartShow}]"
                @click="addToCartButtonClick"
                :key="'button'"
                :loading="disabled"
                :disabled="disabled"
        >
            <span>{{addToCartText}}</span>
        </love-map-button>
        <modal
                v-if="$root.env === 'frontend'"
                name="viewport-confirm"
                height="auto"
                :key="'modal'"
                :pivotY="0.3"
                adaptive
                scrollable
        >
            <div class="viewport-confirm-container">
                <div class="viewport-confirm-message">
                    <div class="lovemap-product-preview">
                        <vue-clazy-load
                                class="lovemap-product-preview--inner"
                                :src="previewUrl"
                                @load="previewUrlLoaded"
                        >
                            <img class="preview-image" :src="previewUrl" alt="preview">
                            <div slot="placeholder">
                                <template v-if="isAcceptDisabled">
                                    <hollow-dots-spinner
                                            style="margin: 0 auto;"
                                            :animation-duration="750"
                                            :size="100"
                                            color="#EC7A5C"
                                    />
                                    <p class="loading-text">Skapar förhandsvisning av din karta</p>
                                    <!--                                eng -> sw-->
                                    <!--                                <p class="loading-text">Rendering preview from server</p>-->
                                </template>
                                <template v-else>
                                    <p class="loading-text">Ett fel har uppstått. Förhandsvisningen kan inte visas. Är
                                        du säker på att kartan ser ut som du tänkt dig kan du fortfarande lägga den i
                                        varukorgen.</p>
                                </template>
                            </div>
                        </vue-clazy-load>

                    </div>
                    <p><strong>Är du säker att din karta ser ut precis som du tänkt dig?</strong></p>
                    <p><i>Din stadskarta kommer tryckas precis som du ser den.</i></p>
                </div>
                <div class="bottom">
                    <div>
                        <love-map-button
                                style="background: #a6a6a6"
                                @click="hideViewportConfirm"
                        >
                            Jag vill göra ändringar
                        </love-map-button>
                    </div>
                    <div>
                        <love-map-button
                                @click="acceptViewportConfirm"
                                :disabled="isAcceptDisabled"
                                :loading="isAcceptDisabled"
                        >
                            Lägg i varukorg
                        </love-map-button>
                    </div>
                </div>
            </div>

        </modal>
        <TxToSaveParams :to-save-params="toSaveParams"/>
    </TxAddToCartPortal>
</template>

<script>
    import HollowDotsSpinner from 'epic-spinners/src/components/lib/HollowDotsSpinner'
    import {VueClazyLoad} from 'vue-clazy-load'
    import CityMapModule from "@packages/tx-products/products/city-map/store-mixin";

    export default {
        name: 'CityMapWooCommerce',
        mixins: [CityMapModule()],
        components: {
            HollowDotsSpinner,
            VueClazyLoad,
        },
        data() {
            return {
                timeoutStatus: false,
                imageLoaded: false,
                disabled: false,
                previewUrl: '',
                addToCartText: '',
                addToCartShow: false
            }
        },
        mounted() {
            if (this.$root.env === 'frontend') {
                // document.body.querySelector('.woocommerce-variation-add-to-cart').appendChild(this.$el);
                this.__addToCartWC = jQuery('.single_add_to_cart_button.button.alt');
                this.replaceAddToCartButton();
            }
        },
        methods: {
            isPreviewTimeoutSet() {
                return !!this._previewTimeout
            },
            async setPreviewLoadingTimeout() {
                this.imageLoaded = false;
                this._previewTimeout = setTimeout(() => {
                    this.timeoutStatus = true
                }, 30000)
            },
            async clearPreviewLoadingTimeout() {
                if (this._previewTimeout) {
                    clearTimeout(this._previewTimeout);
                }
            },
            async resetPreviewTimeout() {
                this.clearPreviewLoadingTimeout()
                this.imageLoaded = false;
                this.timeoutStatus = false
            },
            previewUrlLoaded(event) {
                console.log(event)
                this.imageLoaded = true;
                this.clearPreviewLoadingTimeout();
            },
            replaceAddToCartButton() {
                this.addToCartText = this.__addToCartWC.text();
                this.addToCartShow = true;
            },
            async addToCartButtonClick() {
                if (this.disabled) return;
                await this.resetPreviewTimeout();
                this.setPreviewLoadingTimeout();
                this.disabled = true;
                try {
                    let {data} = await this.$http({
                        method: 'POST',
                        url: `${lovemap.rest}lm/v1/lovemap/preview/`,
                        data: {
                            mapData: this.toSaveParams
                        }
                    })
                    let {url} = data;
                    this.previewUrl = url;
                } catch (e) {
                    console.error(e);
                }
                this.disabled = false;
                this.showViewportConfirm();
            },
            showViewportConfirm() {
                this.$modal.show('viewport-confirm');
            },
            hideViewportConfirm() {
                this.$modal.hide('viewport-confirm');
            },
            acceptViewportConfirm() {
                this.__addToCartWC.click()
                this.$modal.hide('viewport-confirm');
            }
        },
        computed: {
            isAcceptDisabled() {
                return !(this.timeoutStatus || this.imageLoaded);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .viewport-confirm-header {
        width: 100%;
        background: #EC7A5C;
        padding: 10px;

        h4 {
            text-align: center;
            color: white;
        }
    }

    .viewport-confirm-message {
        padding: 35px 25px;
        padding-bottom: 85px;

        p {
            text-align: center;
        }
    }

    .lovemap-product-preview {
        text-align: center;
        margin-bottom: 20px;

        &--inner {
            display: inline-block;
        }

        .loading-text {
            margin-top: 15px;
        }

        .preview-image {
            border: 1px solid #d7d7d7;
        }

        img {
            max-height: 350px;
        }
    }

    .viewport-confirm-container {
        position: relative;
        height: 100%;

        .bottom {
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            /*text-align: center;*/
            > div {
                display: inline-block;
                width: 50%;
                @media only screen and (min-width: 501px) {
                    .lm-button {
                        margin-bottom: 20px;
                    }
                }
                @media only screen and (max-width: 500px) {
                    display: block;
                    width: 100%;
                    margin-bottom: 10px;
                }
                text-align: center;
            }
        }
    }
</style>

<style>
    .v--modal-overlay {
        z-index: 9999 !important;
    }
</style>

